import"./backdrop-dialog.4063af820582.js";

export class CareQuality {
  constructor() {
    this.elements = {
      careQualityButtons: document.querySelectorAll(".tqc-care-quality"),
      careQualityModal: document.getElementById("care-quality-modal"),
    };

    this.bindListeners();
  }

  bindListeners() {
    this.elements.careQualityButtons.forEach((button) => {
      button.addEventListener("click", (evt) => {
        this.elements.careQualityModal.showModal();
      });
    });
  }
}
